var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size,"disabled":_vm.downloading},on:{"click":_vm.onFileDownload}},[(_vm.downloading)?_c('b-spinner',{attrs:{"small":"","variant":"secondary","label":"Downloading..."}}):_c('i',{class:_vm.icon}),_c('span',{class:{ 'ml-1': this.label.length > 0 }},[_vm._v(" "+_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }